import { MdKeyboardArrowDown, MdKeyboardArrowRight } from 'react-icons/md';
import { MenuItemType } from '../../../types/menu';
import React from 'react';

interface SidebarMenuProps {
  sortedItems: MenuItemType[];
  openKeys: string[];
  selectedKeys: string[];
  handleMenuAction: (selectedKey: string, keys: string[], select: boolean) => void;
}

const SidebarMenu: React.FC<SidebarMenuProps> = ({ sortedItems, openKeys, selectedKeys, handleMenuAction }) => {
  return (
    <div className="flex h-5/6 w-auto overflow-y-scroll hide-scrollbar mb-2 mt-2">
      <ul className="w-full">
        {sortedItems.map((item) => (
          <li
            key={item.key}
            className={`relative
            ${
              selectedKeys.includes(item.key)
                ? selectedKeys.length === 1
                  ? 'selected-key'
                  : 'selected-key-parent'
                : ''
            }`}
          >
            <div className="flex flex-row items-center">
              <div
                className="menu-root-item flex flex-1 items-center justify-start cursor-pointer pl-8 h-auto"
                onClick={() => handleMenuAction(item.key, [item.key], true)}
              >
                {item.label}
              </div>
              <div className="flex items-center justify-end mr-auto ml-5">
                {item.children && (
                  <div className="cursor-pointer" onClick={() => handleMenuAction(item.key, [item.key], false)}>
                    {openKeys.includes(item.key) ? (
                      <MdKeyboardArrowDown className="text-soft-blue-grey ml-2 mr-4" />
                    ) : (
                      <MdKeyboardArrowRight className="text-soft-blue-grey ml-2 mr-4" />
                    )}
                  </div>
                )}
              </div>
            </div>

            {item.children && openKeys.includes(item.key) && (
              <ul className="submenu bg-submenu-grey">
                {item.children.map((child) => (
                  <li
                    key={child.key}
                    className={`my-1 relative ${
                      selectedKeys.includes(child.key)
                        ? selectedKeys.length === 2
                          ? 'selected-key'
                          : 'selected-key-parent'
                        : ''
                    }`}
                  >
                    <div
                      className="menu-child-item flex flex-1 items-center justify-between cursor-pointer ml-9 h-auto"
                      onClick={() => handleMenuAction(child.key, [item.key, child.key], true)}
                    >
                      {child.label}
                      <div className="flex items-center justify-end mr-auto ml-5">
                        {child.children && (
                          <div
                            className="cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMenuAction(child.key, [item.key, child.key], false);
                            }}
                          >
                            {openKeys.includes(child.key) ? (
                              <MdKeyboardArrowDown className="text-soft-blue-grey ml-2 mr-4" />
                            ) : (
                              <MdKeyboardArrowRight className="text-soft-blue-grey ml-2 mr-4" />
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {child.children && openKeys.includes(child.key) && (
                      <ul className="submenu bg-medium-dark-grey">
                        {child.children.map((grandchild) => (
                          <li
                            key={grandchild.key}
                            className={`my-1 relative ${
                              selectedKeys.includes(grandchild.key)
                                ? selectedKeys.length === 3
                                  ? 'selected-key'
                                  : 'selected-key-parent'
                                : ''
                            }`}
                          >
                            <div
                              className={`menu-grandchild-item flex flex-1 items-center justify-between cursor-pointer ml-10 h-auto`}
                              onClick={() =>
                                handleMenuAction(grandchild.key, [item.key, child.key, grandchild.key], true)
                              }
                            >
                              {grandchild.label}
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarMenu;
